<template>
    <div class="scenario-container">
        <b-list-group>
            <b-list-group-item v-for="(scenario, index) in ticket.scenarios" :key="index" title="">
                <div v-if="scenario.freespins">{{ 'freespin' | lang }} {{scenario.freespins.current}}/{{scenario.freespins.total}}</div>
                <div class="w-100 pb-2">
                    <div v-for="row in width" :key="`row-${row}`" class="d-flex justify-content-center">
                        <div v-for="(symbols, symbolIndex) in reelMap(scenario.reels)" :key="symbolIndex" :class="`${ticket.id}_${index}_${symbolIndex}_${row-1}`" :ref="`${ticket.id}_${index}_${symbolIndex}_${row-1}`" style="display: block;position: relative;">
                            <div v-if = "inRhombus(row, symbolIndex)" alt="symbol" :style="$parent.getSymbolStyle(symbols[row-1], 50)"></div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <div class="scenario-line" v-for="(match, matchIndex) in scenario.matches" :key="matchIndex" 
                        @mouseleave="changeOpacity(ticket.id, index, 1)" @mouseenter="markMatch(ticket.id, match, index)">
                        <span v-if="match.line">{{ match.line }} {{ 'line' | lang }}</span>
                        <div style = "display: inline-block; position: relative;">
                            <div alt="symbol" :style="$parent.getSymbolStyle(match.symbol, 32)"></div>
                        </div>
                        <span>x{{ match.count }}</span>
                        <span v-if="match.type == 'row'">= {{ ticket.amount * (match.multiplier / scenario.lines_count) | currency }}</span>
                        <span v-else-if="match.type == 'table'">
                            = 
                            <span v-if="match.multiplier"> {{ ticket.amount * match.multiplier | currency }}</span><span v-if="match.multiplier && match.bonuses && match.bonuses.freespins && !index">, </span>
                            <span v-if="match.bonuses && match.bonuses.freespins && !index">{{ 'freespins' | lang }}({{match.bonuses.freespins}})</span>
                        </span>
                    </div>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>

import { range } from 'lodash';

export default {
    props: ['ticket', 'symbolsMapped'],
    data() {
        return {
            gameName: Config.game_name.toLowerCase(),
            height: Config.reels_height,
            width: Config.reels_width,
            paylines: Config.paylines,
            mappedReels: {},
            step: 2
        }
    },
    methods: {
        inRhombus(row, column) {
            if(!this.rhombusPositions[row][column]) {
                return false;
            }
            
            return true;

        },
        reelMap(reels) {
            const map = {};
            
            for (const [ index, step ] of Object.entries(reels)) {
                map[index] = this.reelSymbols(index, step);
            }

            return map;
        },
        reelSymbols(index, step) {
            const symbols = [];

            for (const relativeY of range(0, this.height)) {
                const absoluteIndex = step + relativeY;
                const reelLength = Config.reels[index].length;

                if (absoluteIndex < reelLength) {
                    symbols.push(Config.reels[index][absoluteIndex]);
                } else {
                    symbols.push(Config.reels[index][absoluteIndex - reelLength]);
                }
            }

            return symbols;
        },

        markMatch(ticket_id, match, scenarioIndex, opacity) {
            this.changeOpacity(ticket_id, scenarioIndex, 0.3);

            if(match.line) {
                for (const [ reelIndex, symbolPlace ] of Object.entries(this.paylines[match.line])) {
                    this.$refs[`${ticket_id}_${scenarioIndex}_${reelIndex}_${symbolPlace}`][0].style.opacity = 1;
                }
            } else {
                for(let i = 1; i <= this.width; i++) {
                    for(let y = 0; y < this.height; y++) {
                        if(this.$refs[`${ticket_id}_${scenarioIndex}_${i}_${y}`][0].classList.contains(match.symbol)) {
                            this.$refs[`${ticket_id}_${scenarioIndex}_${i}_${y}`][0].style.opacity = 1;
                        }
                    }
                }
            }
        },
        changeOpacity(ticket_id, scenarioIndex, opacity) {
            for(let i = 1; i <= this.width; i++) {
                for(let y = 0; y < this.height; y++) {
                   this.$refs[`${ticket_id}_${scenarioIndex}_${i}_${y}`][0].style.opacity = opacity;
                }
            }
        },
    },
    computed: {
        rhombusPositions() {
            let positions = {};
            for( let i = 1; i <= this.width; i++ ){
                positions[i] = {};

                if( i <=  Math.round(this.width/2) ){
                    for( let k = 1; k <= ( this.step * i - 1 ); k++ ){
                        let row = ((this.width - (this.step * i - 1)) / this.step) + k;
                        positions[i][row] = true;
                    }
                }else{
                    for( let p = 1; p <= ( this.step * ((this.width + 1) - i ) - 1 ); p++ ){
                        let row = ((this.width - ( this.step * ((this.width + 1) - i ) - 1 )) / this.step) + p;
                        positions[i][row] = true;
                    }
                }
            }

            return positions;
        }
    }
}
</script>
